import { render, staticRenderFns } from "./OrderFilters.vue?vue&type=template&id=d5908ab6&scoped=true&"
import script from "./OrderFilters.vue?vue&type=script&lang=js&"
export * from "./OrderFilters.vue?vue&type=script&lang=js&"
import style0 from "./OrderFilters.vue?vue&type=style&index=0&id=d5908ab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5908ab6",
  null
  
)

export default component.exports